<template>
  <div class="all">
    <!--        <div class="header">"大众评公务"满意度调查问卷</div>-->
    <div class="active">
      <div class="act">
        选择你所在区（县、市）
      </div>
      <div>
        <ul>
          <li
            v-for="(item, index) in departL"
            :key="index"
            :class="chooseI == index ? 'li-checked' : ''"
            @click="toChoose(index)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="bottom">
        <button v-if="activeIsEnd" class="end-btn">调查问卷已结束</button>
        <button v-if="!showToast&&!activeIsEnd" @click="toConfirm()">确认</button>
        <button v-if="showToast&&!activeIsEnd">确认</button>
      </div>
    </div>
    <div class="toast" v-if="showToast">{{ toastText }}</div>
    <div style="color: #f00">{{ phoneN }}</div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        departL: [
          {region_id: 360702, name: "章贡区"},
          {region_id: 360703, name: "南康区"},
          {region_id: 360721, name: "赣县区"},
          {region_id: 360722, name: "信丰县"},
          {region_id: 360723, name: "大余县"},
          {region_id: 360724, name: "上犹县"},
          {region_id: 360725, name: "崇义县"},
          {region_id: 360726, name: "安远县"},
          {region_id: 360727, name: "龙南市"},
          {region_id: 360728, name: "定南县"},
          {region_id: 360729, name: "全南县"},
          {region_id: 360730, name: "宁都县"},
          {region_id: 360731, name: "于都县"},
          {region_id: 360732, name: "兴国县"},
          {region_id: 360733, name: "会昌县"},
          {region_id: 360734, name: "寻乌县"},
          {region_id: 360735, name: "石城县"},
          {region_id: 360781, name: "瑞金市"},
          {region_id: 360782, name: "经开区"},
          {region_id: 360783, name: "蓉江新区"},
        ],
        chooseI: -1,
        regionId: "",
        showToast: false,
        phoneN: "",
        toastText: "",
        activeIsEnd: false,
        ymd_name: '',
        submitList: []
      };
    },
    created() {
      this.isEnd();
      let submitList = localStorage.getItem("zf_xj_submit_list");
      if (submitList) {
        this.submitList = JSON.parse(submitList)
      }
    },
    mounted() {
      let abc = localStorage.getItem("addressF");
      if (abc) {
        abc = JSON.parse(abc);
        this.chooseI = Number(abc.index) - 1;
        this.regionId = abc.id;
      }
    },
    destroyed() {
      // localStorage.removeItem('user');
    },
    methods: {
      isEnd() {
        this.$axios({
          url: "https://dk.jxbashen.com:82/api/dkswitch",
          method: "post",
          data: {
            type: 1
          }
        }).then(res => {
          let {close_status, ymd_name, content} = res.data
          localStorage.setItem("zf_xj_dcwj_content", content);
          localStorage.setItem("zf_xj_dcwj_ymd_name", ymd_name);
          this.ymd_name = ymd_name
          if (close_status == 1) {
            this.activeIsEnd = false;
            localStorage.setItem("activeIsEnd", "false");
          } else if (close_status == 2) {
            this.activeIsEnd = true;
            localStorage.setItem("activeIsEnd", "true");
          }
        });
      },
      toChoose(index) {
        this.chooseI = index;
        this.regionId = this.departL[index].region_id;
      },
      toConfirm() {
        if (this.chooseI == -1) {
          this.toastText = "请先选择您所在地区";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 1500);
          return false
        }
        let index = this.submitList.indexOf(this.ymd_name);
        if (index > -1) {
          this.toastText = "您已经提交过此问卷！";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 1500);
          return false
        }
        let aaa = {
          index: Number(this.chooseI) + 1,
          id: this.regionId
        }
        localStorage.setItem("addressF", JSON.stringify(aaa));
        this.$router.push("/home");
      }
    }
  };
</script>
<style scoped>
  body {
    margin: 0;
    padding: 0;
    width: 100vw;
    height: 100%;

    /*font: verdana;*/
  }

  .toast {
    position: absolute;
    top: 50%;
    width: 50%;
    left: 25%;
    background-color: rgba(0, 0, 0, 0.8);
    height: 6rem;
    z-index: 999;
    color: #fff;
    font-size: 2rem;
    line-height: 6rem;
    border-radius: 20px;
  }

  .all {
    position: relative;
    /*height: 100vh;*/
    /*overflow: hidden;*/
  }

  .li-checked {
    color: #fff;
    background: #1d83ec;
  }

  .header {
    color: #000000;
    height: 5.5rem;
    font-size: 3em;
    line-height: 5.5rem;
    background: rgba(255, 255, 255, 1);
    font-weight: bold;
    text-align: left;
    padding-left: 3%;
  }

  .active {
    padding: 0 4.125rem 0 4.125rem;
    background-color: #f4f4f4;
  }

  .act {
    color: rgba(81, 81, 81, 1);
    margin: 3rem 0 3.75rem;
    font-size: 3rem;
    text-align: left;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #000000;
  }

  ul {
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  p {
    color: #515151;
    font-size: 2.5rem;
    text-indent: 2em;
    text-align: left;
  }

  li {
    width: 30%;
    /*padding-left: 1.25rem;*/
    list-style-type: none;
    margin-bottom: 2rem;
    background-color: white;
    height: 6.25rem;
    line-height: 6.25rem;
    font-size: 2.5rem;
    text-align: center;
    border-radius: 8px;
    margin-right: 5%;
  }

  li:nth-of-type(3n) {
    margin-right: 0;
  }

  .radio_type {
    width: 1.875rem;
    height: 1.875rem;
    appearance: none;
    position: relative;
    outline: none;
    padding-top: 0.375rem;
  }

  button {
    height: 6.25rem;
    background: rgba(29, 131, 236, 1);
    border-radius: 4px;
    color: #ffffff;
    font-size: 2.25rem;
    margin-top: 40%;
    width: 100%;
    border: none;
  }

  .bottom {
    /*width: 100%;*/
    /*position: absolute;*/
    /*bottom: 10rem;*/
  }


  .end-btn {
    background: #e6e6e6;
    color: #494848;
  }

  .qustion {
    margin: 3rem 0;

    font-size: 3rem;
    color: #000000;
    height: 3rem;
    text-align: left;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
  }

  ul span {
    padding-left: 1.25rem;
    font-weight: 500;
    color: #000000;
  }

  input:checked + span {
    color: #1d83ec;
  }

  input {
    vertical-align: text-bottom;
    margin-bottom: 2px;
  }
</style>
